import React, { useEffect, useState } from 'react';
import { Grid, Tabs, Tab, Badge, Box } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import FilterAccordion from 'components/FilterAccordion';
import { SoldProductsFiltersState, FilterAction } from 'hooks/useSoldProductsFilters';
import { InAppSaleType } from 'lib/models/order';

type Props = {
	filters: SoldProductsFiltersState;
	dispatch: React.Dispatch<FilterAction>;
};

export default function DateFilters({ filters, dispatch }: Props) {
	const {
		from,
		to,
		confirmationFrom,
		confirmationTo,
		cancellationFrom,
		cancellationTo,
		reservationFrom,
		reservationTo,
		inAppSaleType,
	} = filters;
	const [dateFilterTab, setDateFilterTab] = useState(0);
	const showReservationTab = inAppSaleType === InAppSaleType.reservation;

	useEffect(() => {
		if (!showReservationTab && dateFilterTab === 3) {
			setDateFilterTab(0);
		}
	}, [showReservationTab, dateFilterTab]);

	return (
		<FilterAccordion
			title="Filtros de Fecha"
			onClear={() => dispatch({ type: 'CLEAR_DATE_FILTERS' })}
			clearTooltip="Limpiar filtros de fecha"
		>
			<Box sx={{ width: '100%' }}>
				<Tabs value={dateFilterTab} onChange={(e, newValue) => setDateFilterTab(newValue)}>
					<Tab
						label={
							<Badge color="primary" variant="dot" invisible={!from && !to}>
								Fecha de creación (Compra)
							</Badge>
						}
					/>
					<Tab
						label={
							<Badge color="primary" variant="dot" invisible={!confirmationFrom && !confirmationTo}>
								Fecha de confirmación (Entrega)
							</Badge>
						}
					/>
					<Tab
						label={
							<Badge color="primary" variant="dot" invisible={!cancellationFrom && !cancellationTo}>
								Fecha de cancelación (Devolución)
							</Badge>
						}
					/>
					{showReservationTab && (
						<Tab
							label={
								<Badge color="primary" variant="dot" invisible={!reservationFrom && !reservationTo}>
									Fecha de reserva
								</Badge>
							}
						/>
					)}
				</Tabs>
				<Box sx={{ pt: 2 }}>
					{dateFilterTab === 0 && (
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={from}
									onChange={(newValue) => dispatch({ type: 'SET_FROM', payload: newValue })}
									label="Comprado desde"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={to}
									onChange={(newValue) => dispatch({ type: 'SET_TO', payload: newValue })}
									minDateTime={from || undefined}
									label="Comprado hasta"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
						</Grid>
					)}
					{dateFilterTab === 1 && (
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={confirmationFrom}
									onChange={(newValue) => dispatch({ type: 'SET_CONFIRMATION_FROM', payload: newValue })}
									label="Entregado desde"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={confirmationTo}
									onChange={(newValue) => dispatch({ type: 'SET_CONFIRMATION_TO', payload: newValue })}
									minDateTime={confirmationFrom || undefined}
									label="Entregado hasta"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
						</Grid>
					)}
					{dateFilterTab === 2 && (
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={cancellationFrom}
									onChange={(newValue) => dispatch({ type: 'SET_CANCELLATION_FROM', payload: newValue })}
									label="Devuelto desde"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={cancellationTo}
									onChange={(newValue) => dispatch({ type: 'SET_CANCELLATION_TO', payload: newValue })}
									minDateTime={cancellationFrom || undefined}
									label="Devuelto hasta"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
						</Grid>
					)}
					{showReservationTab && dateFilterTab === 3 && (
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={reservationFrom}
									onChange={(newValue) => dispatch({ type: 'SET_RESERVATION_FROM', payload: newValue })}
									label="Reservado desde"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<DateTimePicker
									sx={{ width: '100%' }}
									value={reservationTo}
									onChange={(newValue) => dispatch({ type: 'SET_RESERVATION_TO', payload: newValue })}
									minDateTime={reservationFrom || undefined}
									label="Reservado hasta"
									format="DD/MM/YYYY HH:mm"
									ampm={false}
								/>
							</Grid>
						</Grid>
					)}
				</Box>
			</Box>
		</FilterAccordion>
	);
}
